export default __webpack_public_path__ + "static/media/AdBlue_BG.78b0b05a.svg";